
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../../../Components/Text.js";
import { ErrorAlert, InformationAlert } from "../../../Components/Alert.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ImageWidget } from "../../../Widgets/Image/ImageWidget.js";
import { defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation, AppLogoVariant } from "../../../Shared/Shared.js";
import { Msg } from "./Types.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

function AppLogoConfigurationView(props) {
    let elems_3;
    const t = useTranslation()[0];
    let canEditImage;
    const matchValue = props.UserData.Role;
    switch (matchValue) {
        case "toolManager":
        case "user": {
            canEditImage = false;
            break;
        }
        default:
            canEditImage = true;
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_3 = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: t("settings.logo.description"),
    })), delay(() => {
        let elems_2, elems, elems_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-x-6", "gap-y-3"])], (elems_2 = [createElement(TextValue, {
            FontWeight: "bold",
            TestId: "",
            Text: t("settings.logo.wide_title"),
        }), createElement(TextValue, {
            FontWeight: "bold",
            TestId: "",
            Text: t("settings.logo.square_title"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["w-96"])], (elems = [createElement(InformationAlert, {
            Label: t("settings.logo.wide_hint"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["w-96"])], (elems_1 = [createElement(InformationAlert, {
            Label: t("settings.logo.square_hint"),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(ImageWidget, {
            CanEditImage: canEditImage,
            ImageUrl: defaultArg(props.AppLogoConfiguration.WideLogoUrl, ""),
            OnDeleteImage: () => {
                props.Dispatch(new Msg(1, [new AppLogoVariant(0, [])]));
            },
            OnUploadImage: (file) => {
                props.Dispatch(new Msg(0, [new AppLogoVariant(0, []), file]));
            },
        }), createElement(ImageWidget, {
            CanEditImage: canEditImage,
            ImageUrl: defaultArg(props.AppLogoConfiguration.SquareLogoUrl, ""),
            OnDeleteImage: () => {
                props.Dispatch(new Msg(1, [new AppLogoVariant(1, [])]));
            },
            OnUploadImage: (file_1) => {
                props.Dispatch(new Msg(0, [new AppLogoVariant(1, []), file_1]));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            const matchValue_1 = FormState__getValidation(props.FormState, t, "global");
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                return singleton(createElement(ErrorAlert, {
                    Label: matchValue_1,
                }));
            }
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function AppLogoSettings(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, (msg, state) => update_1(props.OnConfigurationChanged, msg, state), (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.AppLogoConfiguration;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems = [createElement(AppLogoConfigurationView, {
            AppLogoConfiguration: matchValue.fields[0],
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

